import { render, staticRenderFns } from "./PanelMixin.vue?vue&type=template&id=2af487c6&scoped=true&"
import script from "./PanelMixin.vue?vue&type=script&lang=ts&"
export * from "./PanelMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af487c6",
  null
  
)

export default component.exports